import { useEffect, useMemo } from 'react'
import { useRulesAcceptedByAccount } from 'state/competition/hooks'
import { updateRulesAccepted } from 'state/competition/reducer'
import { useAppDispatch } from 'state/hooks'

export const useRulesAccepted = (
  account?: string,
  accepted?: boolean
): { isLoading: boolean; data?: boolean; accept: () => void } => {
  const stateAccepted = useRulesAcceptedByAccount(account)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (accepted) {
      accept()
    }
  }, [accepted])

  const accept = () => {
    if (account) {
      dispatch(updateRulesAccepted({ account, rulesAccepted: true }))
    }
  }

  return useMemo(() => {
    return {
      isLoading: accepted === undefined,
      data: accepted || stateAccepted,
      accept,
    }
  }, [stateAccepted, account, accepted])
}
